var map = {
	"./57849227-48cc-4b6e-94af-d2eec0d4409/Footer.vue": [
		2622,
		622
	],
	"./5e5f3a7b-0a0c-4516-874f-eb07ebc7c948/Footer.vue": [
		7752,
		752
	],
	"./Arsenal/Footer.vue": [
		1356,
		356
	],
	"./Folder1/Footer.vue": [
		5263,
		263
	],
	"./ManCity/Footer.vue": [
		5132,
		132
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9881;
module.exports = webpackAsyncContext;